import { Pill } from '../ui/pill'

// A draft log already holds its log number. Naming it "Log #n · Draft" in
// one pill keeps the state obvious in list rows, where a bare number reads
// as a completed log.
export function DraftLogPill({ logNumber }: { logNumber: number }) {
  return <Pill variant="draft">Log #{logNumber} · Draft</Pill>
}
